module.exports = __webpack_public_path__ + "img/fire-experience.a2780d39.webp";